import analytics from "web/script/analytics/analytics";
import globals from "web/script/modules/globals";
import baustein from "baustein";
import "web/script/components/instant-feedback";
var TAB_CLASS = "tabbed-bottom-navigation__tab";
export default baustein.register("tabbed-bottom-navigation", {
  setupEvents: function setupEvents(add) {
    add("click", ".".concat(TAB_CLASS), this.onClick);
  },
  onClick: function onClick(event) {
    event.preventDefault();
    var label = event.target.closest(".".concat(TAB_CLASS)).text;
    analytics.event("Bottom Tab Nav", "Clicked", label).then(function () {
      globals.window.location = event.target.closest("a").href;
    });
  }
});